import { useEffect, useState } from "react";
import { Loader2, Save, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../../lib/api";
import ImageUploader from "../../components/ImageUploader";

export default function AdminSiteContent() {
  const [c, setC] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/site-content").then((r) => setC(r.data)).catch(() => {}); }, []);

  const set = (k, v) => setC((prev) => ({ ...prev, [k]: v }));

  const save = async () => {
    setSaving(true);
    try { const { data } = await api.put("/admin/site-content", c); setC(data); toast.success("Homepage aggiornata"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  if (!c) return <Loader2 className="animate-spin text-fir" />;

  return (
    <div className="max-w-3xl pb-16">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="font-display text-4xl text-fir">Contenuti Homepage</h1>
          <p className="text-fir-deep/60">Modifica testi e immagini della pagina principale del sito.</p>
        </div>
        <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-1 text-sm text-fir hover:text-gold"><ExternalLink size={16} /> Anteprima sito</a>
      </div>

      <Section title="Sezione Hero">
        <Text label="Sopratitolo" k="hero_eyebrow" c={c} set={set} testid="sc-hero-eyebrow" />
        <div className="grid grid-cols-2 gap-4">
          <Text label="Titolo" k="hero_title" c={c} set={set} testid="sc-hero-title" />
          <Text label="Parola evidenziata (oro)" k="hero_title_highlight" c={c} set={set} />
        </div>
        <Area label="Sottotitolo" k="hero_subtitle" c={c} set={set} />
        <ImageUploader label="Immagine Hero (sfondo)" value={c.hero_image ? [c.hero_image] : []}
          onChange={(v) => set("hero_image", v[v.length - 1] || "")} testid="sc-hero-image" />
      </Section>

      <Section title="Sezione Territorio / Storytelling">
        <Text label="Sopratitolo" k="story_eyebrow" c={c} set={set} />
        <Text label="Titolo" k="story_title" c={c} set={set} testid="sc-story-title" />
        <Area label="Paragrafo 1" k="story_p1" c={c} set={set} />
        <Area label="Paragrafo 2" k="story_p2" c={c} set={set} />
        <Text label="Località (badge)" k="story_location" c={c} set={set} />
        <Text label="Valutazione (es. 4.9)" k="rating_value" c={c} set={set} />
        <ImageUploader label="Immagine territorio" value={c.story_image ? [c.story_image] : []}
          onChange={(v) => set("story_image", v[v.length - 1] || "")} testid="sc-story-image" />
      </Section>

      <Section title="Titoli delle sezioni">
        <div className="grid grid-cols-2 gap-4">
          <Text label="Appartamento · sopratitolo" k="apartments_eyebrow" c={c} set={set} />
          <Text label="Appartamento · titolo" k="apartments_title" c={c} set={set} />
          <Text label="Esperienze · sopratitolo" k="experiences_eyebrow" c={c} set={set} />
          <Text label="Esperienze · titolo" k="experiences_title" c={c} set={set} />
          <Text label="Recensioni · sopratitolo" k="reviews_eyebrow" c={c} set={set} />
          <Text label="Recensioni · titolo" k="reviews_title" c={c} set={set} />
        </div>
        <Area label="Esperienze · sottotitolo" k="experiences_subtitle" c={c} set={set} />
      </Section>

      <Section title="Footer & Contatti">
        <Area label="Tagline footer" k="footer_tagline" c={c} set={set} />
        <div className="grid grid-cols-2 gap-4">
          <Text label="Email di contatto" k="contact_email" c={c} set={set} testid="sc-contact-email" />
          <Text label="Indirizzo" k="contact_address" c={c} set={set} />
        </div>
        <Text label="Query mappa Google (es. Dimaro,Val di Sole)" k="map_query" c={c} set={set} />
      </Section>

      <button data-testid="save-site-content-btn" onClick={save} disabled={saving}
        className="gold-btn w-full py-3.5 rounded-xl mt-6 flex items-center justify-center gap-2">
        {saving ? <Loader2 className="animate-spin" size={18} /> : <><Save size={18} /> Salva homepage</>}
      </button>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section className="bg-white rounded-2xl border border-stone p-6 mb-5 space-y-4">
      <h2 className="font-display text-2xl text-fir">{title}</h2>
      {children}
    </section>
  );
}
const Label = ({ children }) => <label className="text-xs uppercase tracking-wide text-fir-deep/60">{children}</label>;
function Text({ label, k, c, set, testid }) {
  return <div><Label>{label}</Label>
    <input data-testid={testid} value={c[k] || ""} onChange={(e) => set(k, e.target.value)} className="input-alpine w-full mt-1" /></div>;
}
function Area({ label, k, c, set }) {
  return <div><Label>{label}</Label>
    <textarea value={c[k] || ""} onChange={(e) => set(k, e.target.value)} className="input-alpine w-full h-20 mt-1" /></div>;
}
